import { TenantSettingsPublicESignaturesDto } from './tenant-settings-public-e-signatures.dto';
import { TenantSettingsPublicGpsTrackersDto } from './tenant-settings-public-gps-trackers.dto';
import { TenantSettingsPublicPaymentProvidersDto } from './tenant-settings-public-payment-providers.dto';

export class TenantSettingsPublicIntegrationsDto {
  gpsTrackers?: TenantSettingsPublicGpsTrackersDto | null;
  paymentProviders?: TenantSettingsPublicPaymentProvidersDto | null;
  eSignatures?: TenantSettingsPublicESignaturesDto | null;
}
